export function fetch(id) { return { type: 'AFFILIATES/FETCH', id } }


// WEBPACK FOOTER //
// ./src/redux-sagas/actions/affiliates.js